import { AuthorizedAvatar, CompanyAccount, PersonAccount } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * Provides CRUD access for authenticated user to access a his/her own authorized accounts
 */
export class AuthorizedAccounts extends CrudApiBase<AuthorizedAvatar, never> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/accounts/authorizedAccount";

  constructor(ajax: Ajax) {
    super(ajax);
  }

  /**
   * Returns an empty avatar without any values.
   */
  public getBlank(): AuthorizedAvatar {
    return {
    };
  }

  /**
   * Lists all accounts on behalf of which this account has been authorized to act.
   *
   * @returns A Promise with result data (list of account objects).
   */
  public getAuthorizingAccounts(): Promise<(PersonAccount|CompanyAccount)[]> {
    const method = "/accounts/authorizingAccount";
    return this.ajax.getJSON(method);
  }

  /**
   * Lists all accounts that have authorized the current account to act on their behalf.
   * Makes a GET request to the API base URL using the configured Ajax instance.
   * @returns A Promise that resolves to an array of PersonAccount and CompanyAccount objects
   */
  public getAll(): Promise<(PersonAccount|CompanyAccount)[]> {
    return this.ajax.getJSON(this.baseUrl);
  }

  /**
   * OData query is not supported for authorized accounts.
   * @param _query OData query parameters (not used)
   * @throws Error indicating operation is not supported
   */
  public getOData(_query: any): any {
    throw new Error("Not supported.");
  }

  /**
   * Getting a single authorized account is not supported.
   * @param _id Identifier of the account (not used)
   * @throws Error indicating operation is not supported
   */
  public getSingle(_id: any): any {
    throw new Error("Not supported.");
  }
}
